/**
 * `S.2`: текст отказа переключателя опроса. На 409 `station_charging` причина
 * своя — выключить можно только после окончания заряда.
 */
export function pollingErrorMessage(error: any, stationNumber: number | string): string {
  const status = error?.response?.status;
  const data = error?.response?.data;
  // `S.2.1` (`АУД-Н265`): отказ различается по коду в `errors`, а не по тексту.
  const code = data?.errors?.[0]?.code;

  if (status === 409 && code === "station_charging") {
    return `Станция ${stationNumber} заряжает — выключить можно после окончания заряда`;
  }

  return data?.message || data?.error || "Переключатель опроса не сохранён";
}
